
export const setCookie = (cookieName, cookieValue, expiryDays) => {
  if (typeof window === "undefined") return;
  let expires = "";
  if (expiryDays) {
    const d = new Date();
    d.setTime((d.getTime() + expiryDays) * (24 * 60 * 60 * 1000));
    expires = `expires=${d.toUTCString()};`;
  }
  if (window.location.host.includes("localhost")) {
    document.cookie = `${cookieName}=${cookieValue};${expires}path=/`;
  } else {
    document.cookie = `${cookieName}=${cookieValue};${expires}path=/; secure; domain=.${process.env.REACT_APP_BASE_URL}`;
  }
};
 export function validateEmail(email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test(email);
}
export function calculateAge(dob) {
  var diff_ms = Date.now() - dob.getTime();
  var age_dt = new Date(diff_ms);
  return Math.abs(age_dt.getUTCFullYear() - 1970);
}

export const getCookie = (key, cookieString) => {
  if (cookieString) {
    return cookieString.replace(
      new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*\\=\\s*([^;]*).*$)|^.*$`),
      "$1"
    );
  } else if (typeof window === "undefined") return "";
  return document.cookie.replace(
    new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*\\=\\s*([^;]*).*$)|^.*$`),
    "$1"
  );
};

export const deleteAllCookies = () => {
  var cookies = document.cookie.split(";");
  if (window.location.host.includes("localhost")) {
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01-Jan-70 00:00:01 GMT;path=/";
    }
  } else {
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie =
        name +
        "=;expires=Thu, 01-Jan-70 00:00:01 GMT;path=/ domain=.${process.env.REACT_APP_BASE_URL}";
    }
  }
};